export default __webpack_public_path__ + "static/data-more-about-img3--mobile-56adcb5bc9a66785efea3f0f8cebd07b.png";